import Vue from 'vue';
import CarefulWishApp from './CarefulWishApp.vue';

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(CarefulWishApp),
}).$mount('#careful-wish-app');
